// src/components/Solutions.js
import React from "react";
import { motion } from "framer-motion";

const Solutions = () => (
  <motion.section
    className="section"
    id="solutions"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
  >
    <h2>Our Solutions</h2>
    <ul>
      <li>⚙️ Autonomous Spraying Robots</li>
      <li>🌱 Weed Control Systems</li>
      <li>🧺 Load-Carrying Field Robots</li>
      <li>🍓 Harvesting Robots for Polyhouse & Outdoor</li>
      <li>📊 Smart Monitoring & Data Systems</li>
    </ul>
  </motion.section>
);

export default Solutions;
